const TRUTHY = new Set(["1", "true", "yes", "on"]);

export function isDevAuthBypassEnabled() {
  if (process.env.NODE_ENV === "production") return false;

  const explicit = (process.env.REACT_APP_DEV_AUTH_BYPASS || "").trim().toLowerCase();
  return explicit ? TRUTHY.has(explicit) : false;
}
